export const environment = {
  linkedInAuthEnabled: process.env.REACT_APP_LINKEDIN_AUTH_ENABLED === "true",
  locationApiUrl: process.env.REACT_APP_LOCATION_API_URL,
  manticoreApiUrl: process.env.REACT_APP_MANTICORE_API_URL,
  rssApiUrl: process.env.REACT_APP_RSS_API_URL,
  authServerUrl: process.env.REACT_APP_AUTH_SERVER_URL,
  notificationApiUrl: process.env.REACT_APP_NOTIFICATION_API_URL,
  ipAddressResolverUrl: process.env.REACT_APP_IP_ADDRESS_RESOLVER_URL,
  authClientIpHintEnabled:
    process.env.REACT_APP_AUTH_CLIENT_IP_HINT_ENABLED == null
      ? process.env.NODE_ENV === "development"
      : process.env.REACT_APP_AUTH_CLIENT_IP_HINT_ENABLED === "true",
};

export function requireHttpServiceUrl(
  value: string | undefined,
  variableName: string,
): string {
  if (!value?.trim()) {
    throw new Error(`${variableName} must be configured`);
  }

  let parsedUrl: URL;
  try {
    parsedUrl = new URL(value.trim());
  } catch {
    throw new Error(`${variableName} must be a valid absolute URL`);
  }

  if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
    throw new Error(`${variableName} must use HTTP or HTTPS`);
  }

  return parsedUrl.toString().replace(/\/$/, "");
}
